module.exports = __webpack_public_path__ + "img/17-OTJS-anticipate-and-meet-employer-expectations.d1e0fe24.svg";